ko.bindingHandlers.submitValidate = {
  init: function (element, valueAccessor, allBindings, viewModel, context) {
    $(element).on("submit", function (ev) {
      var isValid = true;
      var invalidProp = null;

      for (var i in viewModel) {
        var prop = viewModel[i];

        if (prop && prop._revalidate) prop._revalidate();

        if (prop && prop.hasError && prop.hasError()) {
          isValid = false;
          invalidProp = i;
          break;
        }
      }

      element.classList.add("was-validated");

      if (!isValid) {
        element.classList.add("is-invalid");
        console.log("invalid prop", invalidProp);
        ev.preventDefault();
        ev.stopImmediatePropagation();
      }
    });

    ko.bindingHandlers.submit.init(
      element,
      valueAccessor,
      allBindings,
      viewModel,
      context
    );
  },
};

ko.bindingHandlers.isValid = {
  /**
   *
   * @param {HTMLBaseElement} element -
   * @param {any} valueAccessor -
   * @param {any} allBindings -
   */
  init: function (element, valueAccessor) {
    ko.bindingHandlers.isValid.update(element, valueAccessor);
  },
  update: function (element, valueAccessor) {
    if (ko.unwrap(valueAccessor())) {
      element.setCustomValidity("invalid");
    } else {
      element.setCustomValidity("");
    }
  },
};
